import React from "react";
import phoneImg from '../../Assets/images/phone.png'
import iosQRIcon from '../../Assets/images/ios_qr.png'
import playstoreQRIcon from '../../Assets/images/playstore_qr.png'
import splashImg from '../../Assets/images/splash.png'
import loginProfileImg from '../../Assets/images/login_profiles.png'
import appStoreIcon from '../../Assets/icon/appstoer_icon.png'
import playStoreIcon from '../../Assets/icon/playstore_icon.png'
import arrowImg from '../../Assets/images/arrow.png'
import { Button } from "@mui/material";


const InvoicePDF = ({
  previewInvoiceList,
  componentRef,
  outerCard,
  innerPad,
  qrCodeData,
  orange = "#ff6a00",
}) => {
  /* ================= HELPERS ================= */


  const round2 = (n) => Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;

  const formatAmount = (val) => round2(val).toFixed(2);

  const formatDateTime = (dt) => {
    if (!dt) return "-";
    const d = new Date(dt);
    return d.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getDiscountValue = (item) => {
    // Use discount value from offer
    if (item?.offer?.discountValue != null && item?.offer?.discountValue > 0) {
      return round2(item.offer.discountValue);
    }
    return 0;
  };

  const getBeforeDiscountBasePrice = (item) => {
    // Use the beforeDiscountBasePrice from API if available
    if (item?.beforeDiscountBasePrice != null) {
      return round2(item.beforeDiscountBasePrice);
    }
    // Fallback: use service amount
    const discount = getDiscountValue(item);
    if (discount > 0) {
      return round2(item.serviceAmount || 0);
    }
    return round2(item.basePrice || 0);
  };

  const getBeforeDiscountGST = (item) => {
    // Use the beforeDiscountGstPrice from API if available
    if (item?.beforeDiscountGstPrice != null) {
      return round2(item.beforeDiscountGstPrice);
    }
    // Fallback: calculate from service amount
    if (item?.gstValue && item?.serviceAmount) {
      return round2((item.serviceAmount * item.gstValue) / 100);
    }
    return 0;
  };

  const getBeforeDiscountTotal = (item) => {
    // Use the beforeDiscountFinalAmount from API if available
    if (item?.beforeDiscountFinalAmount != null) {
      return round2(item.beforeDiscountFinalAmount);
    }
    // Fallback: calculate
    const beforeDiscountBase = getBeforeDiscountBasePrice(item);
    const beforeDiscountGST = getBeforeDiscountGST(item);
    return round2(beforeDiscountBase + beforeDiscountGST);
  };

  /* ================= TOTALS ================= */

  // Subtotal after discount: sum of all base prices
  const subtotalAfterDiscount =
    previewInvoiceList?.services?.reduce(
      (sum, item) => sum + round2(item.basePrice || 0),
      0
    ) || 0;

  // Total GST after discount
  const totalGSTAfterDiscount =
    previewInvoiceList?.services?.reduce(
      (sum, item) => sum + round2(item.gstPrice || 0),
      0
    ) || 0;

  // Grand totals
  // const grandTotalBeforeDiscount = round2(subtotalBeforeDiscount + totalGSTBeforeDiscount);
  const grandTotalAfterDiscount = round2(subtotalAfterDiscount + totalGSTAfterDiscount);

  /* ================= RENDER ================= */

  return (
    
    <div ref={componentRef} style={outerCard}>
      <div style={innerPad}>
        <div className="section-one">
        {/* ================= HEADER ================= */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 26, fontWeight: 800, color: orange }}>
              INVOICE
            </div>

            <div style={{ fontSize: 15, fontWeight: 700 }}>
              {previewInvoiceList?.providerId?.business?.name}
            </div>

            <div style={{ fontSize: 13, color: "#555" }}>
              {previewInvoiceList?.branchId?.building},{" "}
              {previewInvoiceList?.branchId?.street}
            </div>

            <div style={{ fontSize: 13, color: "#555" }}>
              {previewInvoiceList?.branchId?.city},{" "}
              {previewInvoiceList?.branchId?.state?.name}{" "}
              {previewInvoiceList?.branchId?.zipCode}
            </div>

            <div style={{ fontSize: 13, color: "#555" }}>
              Phone: {previewInvoiceList?.branchId?.mobileNumber}
            </div>

            <div style={{ fontSize: 13 }}>
              <strong>GSTIN:</strong>{" "}
              {previewInvoiceList?.branchId?.gstNumber}
            </div>
          </div>

          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 12, color: "#999" }}>Invoice No</div>
            <div style={{ fontSize: 18, fontWeight: 700 }}>
              {previewInvoiceList?.refNumber}
            </div>

            <div style={{ fontSize: 12, color: "#999", marginTop: 12 }}>
              Date
            </div>
            <div style={{ fontWeight: 700 }}>
              {new Date().toLocaleDateString("en-US")}
            </div>
          </div>
        </div>

        <hr style={{ margin: "24px 0" }} />

        {/* ================= BILL TO ================= */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 11, color: "#999" }}>BILL TO</div>

          <div style={{ fontSize: 16, fontWeight: 700 }}>
            {previewInvoiceList?.clientId?.name}
          </div>

          <div style={{ fontSize: 13, color: "#555" }}>
            Branch: {previewInvoiceList?.branchId?.name}
          </div>

          <div style={{ fontSize: 13, color: "#555" }}>
            Visit Type: {previewInvoiceList?.visitType}
          </div>

          <div style={{ fontSize: 13, color: "#555" }}>
            Service Date:{" "}
            {formatDateTime(previewInvoiceList?.startDateTime)}
          </div>
        </div>

        {/* ================= SERVICES TABLE ================= */}
        <table
          className="table table-bordered"
          style={{ width: "100%", borderCollapse: "collapse" }}
        >
          <thead>
            <tr style={{backgroundColor:'#FEEADA'}}>
              <th style={{ width: "5%" }}>#</th>
              <th>Service</th>
              <th className="text-end" style={{ width: "20%" }}>
                Base Price
              </th>
              <th className="text-end" style={{ width: "15%" }}>
                GST
              </th>
              <th className="text-end" style={{ width: "20%" }}>
                Total
              </th>
            </tr>
          </thead>

          <tbody>
            {previewInvoiceList?.services?.map((item, index) => {
              const discountValue = getDiscountValue(item);
              const hasDiscount = discountValue > 0;
              const beforeDiscountBase = getBeforeDiscountBasePrice(item);
              const beforeDiscountGST = getBeforeDiscountGST(item);
              const beforeDiscountTotal = getBeforeDiscountTotal(item);

              return (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
                    <div>{item.serviceName}</div>
                  </td>

                  {/* Base Price */}
                  <td className="text-end">
                    <div>{previewInvoiceList?.currencySymbol}{formatAmount(item.basePrice)}</div>
                  </td>

                  {/* GST */}
                  <td className="text-end">
                    <div>{previewInvoiceList?.currencySymbol}{formatAmount(item.gstPrice)}</div>
                  </td>

                  {/* Total */}
                  <td className="text-end fw-bold">
                    {previewInvoiceList?.currencySymbol}{formatAmount(item.finalAmount)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* ================= TOTALS ================= */}

        <div style={{ width: "40%", marginLeft: "auto" }}>
  {/* Subtotal */}
  <div className="d-flex justify-content-between mb-2">
    <div className="fw-bold">Subtotal</div>
    <div className="text-end">
      {previewInvoiceList?.currencySymbol}{formatAmount(subtotalAfterDiscount)}
    </div>
  </div>

  {/* Total GST */}
  <div className="d-flex justify-content-between mb-2">
    <div className="fw-bold">Total GST</div>
    <div className="text-end">
      {previewInvoiceList?.currencySymbol}{formatAmount(totalGSTAfterDiscount)}
    </div>
  </div>

  {/* Additional Discount */}
  {  previewInvoiceList?.additionalOffer?.discount !== 0 && (
  <div className="d-flex justify-content-between border-top pt-2 mb-2">
    <div style={{ fontSize: 16 }}>
      Additional Discount
    </div>
    <div className="text-end" style={{ fontSize: 16 }}>
      {previewInvoiceList?.currencySymbol}{
        previewInvoiceList?.additionalOffer?.discountType === "FLAT"
          ? previewInvoiceList?.additionalOffer?.discount
          : `(${previewInvoiceList?.additionalOffer?.discount}%) ${previewInvoiceList?.additionalOffer?.discountPrice}`
      }
    </div>
  </div>
  )}

  {/* Grand Total */}
  <div
    className="d-flex justify-content-between"
    style={{
      backgroundColor: "#FFF3EA",
      borderRadius: "10px",
      padding: "10px"
    }}
  >
    <div className="fw-bold p-3" style={{ fontSize: 16 }}>
      Grand Total
    </div>
    <div
      className="text-end fw-bold p-3"
      style={{ fontSize: 16, color: orange }}
    >
      {previewInvoiceList?.currencySymbol}{formatAmount(grandTotalAfterDiscount)}
    </div>
  </div>
       </div>
        </div>

    <hr style={{ margin: "13px 0" }} />
    {/* <div className="page-break-before"></div> */}
    <div className="iskedo-page">

    <div className="section-two">
    <div className="iskedo-wrapper">
      {/* Rounded background shapes */}
      <div className="bg-blob bg-blob-left"></div>
      <div className="bg-blob bg-blob-bottom"></div>

      <div className="container-fluid p-5">
        <div className="row align-items-start">
          <div>
            {/* Title */}
            <h2 className="fw-bold mb-3 text-center">
              <span style={{ color: orange }}>ISKEDO</span>{" "}
              <span>FOR CUSTOMERS</span>
            </h2>

            <div className="row">
              <div className="col-md-6">
                {/* Description */}
                <p className="text-muted mb-4" style={{ maxWidth: "520px" }}>
                  Download the Iskedo Client App. Book appointments, chat with
                  providers, get reminders & offers — all in one place!
                </p>

                {/* App Store Section */}
                <div className="d-flex gap-4 mb-4">
                  {/* IOS */}
                  <div className="text-center d-flex flex-column align-items-center">
                    <img src={appStoreIcon} alt="ios" height={25} />
                    <div className="fw-semibold my-2" style={{fontSize:'14px'}}>
                      Client App - IOS
                    </div>
                    <img src={iosQRIcon} alt="ios qr" width={65} />
                  </div>

                  {/* ANDROID */}
                  <div className="text-center d-flex flex-column align-items-center">
                    <img src={playStoreIcon} alt="android" height={25} />
                    <div className="fw-semibold my-2" style={{fontSize:'14px'}}>
                      Client App - Android
                    </div>
                    <img src={playstoreQRIcon} alt="android qr" width={65} />
                  </div>
                </div>

                <p className="text-muted" style={{ maxWidth: "520px" }}>
                  Sign in with your mobile number and create your profile
                  (Optional to create multiple profiles in same login)
                </p>
              </div>

              <div className="col-md-6 text-center">
                <img src={phoneImg} alt="phone" width={150} />
              </div>
            </div>

            {/* Steps */}
            <div className="mt-2">
              <h6 className="fw-bold mb-2">Step to add service provider</h6>

              {/* Step 1 */}
              <div className="row align-items-center mb-3">
                <div className="col-md-6 position-relative">
                  <span className="fw-bold me-2" style={{ color: orange }}>
                    1.
                  </span>
                  Enter to the desired profile

                  <img
                    src={arrowImg}
                    alt="arrow"
                    className="step-arrow"
                  />
                </div>

                <div className="col-md-6 text-center">
                  <img src={loginProfileImg} width={150} alt="profile" />
                </div>
              </div>

              {/* Step 2 */}
              <div className="row align-items-center">
                <div className="col-md-6 position-relative">
                  <span className="fw-bold me-2" style={{ color: orange }}>
                    2.
                  </span>
                  Scan to add service provider

                  <img
                    src={arrowImg}
                    alt="arrow"
                    className="step-arrow"
                  />

                  <div className="mt-5">
                    <div
                      className="shadow bg-white rounded p-1"
                      style={{ width: "80px" }}
                      dangerouslySetInnerHTML={{ __html: qrCodeData }}
                    />
      <div style={{marginLeft:'0px'}}>
 
                      <div className="text-center mt-3" style={{background:'#fff', color:'#000', width:'80px', padding:'3px', borderRadius:'50px', fontSize:'13px'}}>
                      SCAN ME
                      </div>
       
       </div>
                  </div>
                </div>

                <div className="col-md-6 text-center">
                  <img src={splashImg} width={150} alt="scan screen" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-5 text-muted small">
          A PRODUCT OF ZIMO TECHNOLOGIES PVT. LTD.
        </div>
      </div>
    </div>
        <hr style={{ margin: "13px 0" }} />
        {/* ================= FOOTER ================= */}
        <div style={{ textAlign: "center" }}>
          <div style={{ fontWeight: 700 }}>Thank you for your visit!</div>
          <div style={{ fontSize: 13, color: "#999" }}>
            For any queries, please contact{" "}
            {previewInvoiceList?.branchId?.name}
          </div>
        </div>
    </div>
    </div>
      </div>
    </div>
  );
};

export default InvoicePDF;